import React from "react";
import { useMediaQuery } from "react-responsive";

import { Container, Divider, Paper } from "@mui/material";
import PackSelector from "./PackSelector";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import SharedPackDisplay from "./SharedPackDisplay";
import Collapse from "@mui/material/Collapse";
import {
  getColorWithMode,
  getBorder,
  HEADING_FONT,
} from "../constants/colors";
import { Archive, Download, Undo2 } from "lucide-react";

const SideNav = ({
  tableId,
  setTableId,
  setTableData,
  packName,
  setPackName,
  defaultPackId,
  setDefaultPackId,
  setImportDialogIsOpen,
  setGearClosetIsOpen,
  setPackDescription,
  setPackIsLoading,
  packIsLoading,
  handleSelectNewPack,
  isSideNavOpen,
  darkMode,
  setPackSettingsTags,
  setPackAnalytics,
  setPackVisibility,
  setAffiliateLinksAreOff,
  setPackCurrency,
  gearClosetIsOpen,
}) => {
  const isDesktopOrLaptop = useMediaQuery({ minWidth: 1380 });

  const sideNavIsOpen = isSideNavOpen || isDesktopOrLaptop;
  return (
    <Collapse
      in={sideNavIsOpen}
      orientation="horizontal"
      sx={{ minWidth: sideNavIsOpen ? "240px !important" : "" }}
    >
      <Paper
        elevation={0}
        style={{
          backgroundColor: getColorWithMode(darkMode, "nav"),
          borderRadius: "0px",
          width: "240px",
          height: "100%",
          borderRight: `1px solid ${getBorder(darkMode)}`,
        }}
      >
        <Stack
          className="toggle-button-group-scroller"
          sx={{
            height: "100svh",
            position: "sticky",
            top: "0px",
            marginBottom: "50px",
            overflowY: "auto",
            overflowX: "hidden",
            paddingBottom: "24px",
          }}
        >
          <img
            src="/pack_wizard.png"
            onClick={() => {
              window.location = `${window.location.origin}?navigatedToHome=true`;
            }}
            className="packshrink-logo"
            alt="Pack Wizard"
          />
          <Container sx={{ marginTop: "20px" }}>
            <Stack gap={1} alignItems="center">
              <PackSelector
                tableId={tableId}
                packName={packName}
                setTableId={setTableId}
                setTableData={setTableData}
                setPackName={setPackName}
                setPackDescription={setPackDescription}
                defaultPackId={defaultPackId}
                setDefaultPackId={setDefaultPackId}
                setPackIsLoading={setPackIsLoading}
                packIsLoading={packIsLoading}
                handleSelectNewPack={handleSelectNewPack}
                darkMode={darkMode}
                setPackSettingsTags={setPackSettingsTags}
                setPackAnalytics={setPackAnalytics}
                setPackVisibility={setPackVisibility}
                setAffiliateLinksAreOff={setAffiliateLinksAreOff}
                setPackCurrency={setPackCurrency}
              />
              <Button
                fullWidth
                variant={darkMode ? "outlined" : "contained"}
                disableElevation
                color="success"
                startIcon={<Download size={18} />}
                sx={{
                  borderRadius: "9px",
                  fontFamily: HEADING_FONT,
                  fontWeight: 600,
                  textTransform: "none",
                }}
                onClick={() => {
                  setImportDialogIsOpen(true);
                }}
              >
                Import Pack
              </Button>
              <Divider width="100%" sx={{ marginTop: "10px" }} />
              <Button
                sx={{
                  marginTop: "10px",
                  borderRadius: "9px",
                  fontFamily: HEADING_FONT,
                  fontWeight: 600,
                  textTransform: "none",
                }}
                fullWidth
                variant={darkMode ? "outlined" : "contained"}
                disableElevation
                color="info"
                startIcon={
                  gearClosetIsOpen ? <Undo2 size={18} /> : <Archive size={18} />
                }
                onClick={() => {
                  setGearClosetIsOpen(!gearClosetIsOpen);
                }}
              >
                {gearClosetIsOpen ? "Back to Pack" : "Gear Closet"}
              </Button>
            </Stack>
          </Container>
          <SharedPackDisplay darkMode={darkMode} />
        </Stack>
      </Paper>
    </Collapse>
  );
};

export default SideNav;
